import React, { Component } from 'react';
import { filter, isEmpty } from 'lodash';
import AmsTable from '../../../utils/AmsTable';
import AmsDateFormatters from '../../../utils/AmsDateFormatters';

class SharedWithTableComponent extends Component {
  sharedBy = (cell, row) => {
    if (row && !isEmpty(row.sharedBy)) {
      return <>{row.sharedBy.fullName && row.sharedBy.fullName}</>;
    }
  };

  sharedWith = (cell, row) => {
    if (row && !isEmpty(row.sharedWith)) {
      return <>{row.sharedWith.fullName && row.sharedWith.fullName}</>;
    }
  };

  sharedDateFormatter = (cell, row) => {
    if (row && row.sharedDate) {
      const date = new Date(row.sharedDate);
      return <>{AmsDateFormatters.getMoment(date).format('L')}</>;
    }
  };

  expirationDateFormatter = (cell, row) => {
    if (row && row.expirationDate) {
      const date = new Date(row.expirationDate);
      return <>{AmsDateFormatters.getMoment(date).format('L')}</>;
    }
  };

  renderSharedWithTable() {
    const { newReport } = this.props;

    const data =
      newReport &&
      newReport.sharedMessages &&
      newReport.sharedMessages.length > 0 &&
      filter(newReport.sharedMessages, message => {
        if (!isEmpty(message.sharedWith)) return message;
      });

    const columns = [
      {
        formatter: this.sharedBy,
        dataField: 'sharedBy.fullName',
        text: 'Shared By',
        sort: true,
        headerStyle: {
          width: '30%',
        },
      },
      {
        formatter: this.sharedWith,
        dataField: 'sharedWith.fullName',
        text: 'Shared With',
        sort: true,
        headerStyle: {
          width: '30%',
        },
      },
      {
        dataField: 'sharedDate',
        text: 'Shared Date',
        sort: true,
        formatter: this.sharedDateFormatter,
      },
      {
        dataField: 'expirationDate',
        text: 'Expiration Date',
        sort: true,
        formatter: this.expirationDateFormatter,
      },
      {
        dataField: 'taskStatus',
        text: 'Task Status',
        sort: true,
      },
      {
        dataField: 'location',
        text: 'Location',
        sort: true,
      },
    ];

    return (
      <div>
        <AmsTable
          data={data || []}
          remote={false}
          total={data && data.length}
          keyField="_id"
          columns={columns}
          pagination={false}
          options={{
            hideSizePerPage: true,
            showTotal: false,
          }}
          showTotal={false}
          paginationTotalHeaderSize="h3"
          basic={data && data.length ? false : true}
          sizePerPageOption={data && data.length ? true : false}
        />
      </div>
    );
  }

  render() {
    return this.renderSharedWithTable();
  }
}

export default SharedWithTableComponent;
